/* eslint-disable */
/* istanbul ignore file */
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import {
  fetchAssetCategories,
  fetchGatewayType,
  fetchGatewayInfo,
  updateGateway,
  downloadImage,
  imageUpload,
  fetchTimeZones
} from '../../redux/actionCreators'
import { type AssetCategoriesState } from '../../redux/assetCategoriesSliceGateway'
import { type GatewayTypeState } from '../../redux/gatewayTypeSlice'
import { type GatewayInfoState } from '../../redux/gatewayInfoSliceGateway'
import { type DownloadImageState } from '../../redux/downloadImageSliceGateway'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import { type RootState } from '../../../../store'
import { type OperationPermissionState } from '../../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import { getOperationPermissions } from '../../../dashboard/redux/actionCreator'
import Link from '@mui/material/Link'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'
import GatewayInformation from './GatewayInformation'
import AddGatewayDummy from '../../../../assets/AddDeviceDummy/image.png'
import { type UpdateGatewayPutRequest } from '../../services/updateGatewayService'
import { type UpdateGatewayState } from '../../redux/updateGatewaySlice'
import Modal from '../../../../components/Modal'
import { CircularProgress } from '@mui/material'
// import CustomToast from '../ToastComponent'
import { type ImageUploadState } from '../../redux/imageUploadSliceGateway'
import { type ImageUploadPostRequest } from '../../services/imageUploadService'
import { isValidGatewayPort, isValidGatewayData, isValidIp } from '../../../../utils/validator'
import { reset } from '../../redux/updateGatewaySlice'
import { ImageUploadReset } from '../../redux/imageUploadSliceGateway'
import { useDispatch } from 'react-redux'
import { APIConfiguration } from '../../../../utils/apiConfiguration'
import AuthError from "../../../../components/ErrorComponents/AuthError"
import { useLocation } from 'react-router-dom'
import { getCustomDeviceDropdownMetadata } from '../../../custom-device/redux/actionCreators'
import { type DeviceDropDownMetadataState } from '../../../custom-device/redux/getDeviceDropDownMetaDataSlice'
import { type TimezoneDataState } from '../../redux/timezoneDataSlice'

const httpStatus = APIConfiguration
const MAX_LENGTH = 100
const MAX_GATEWAY_DESCRIPTION_LENGTH = 500
const AddGatewayStrings = LanguageStrings().GatewayManagementCollectionStrings.AddGatewayComponent
const DashboardStrings = LanguageStrings().Dashboard

interface LabelValue {
  label: string
  value: string
}

const EditGateway = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const stateLocation = useLocation()
  const { gatewayIdParam } = useParams() as { gatewayIdParam: string };
  const [isGatewayDetailsEnabled, setIsGatewayDetailsEnabled] = React.useState(true)
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  )
  const [categoryTypeId, setCategoryTypeId] = React.useState('')
  const [assetTypeId, setAssetTypeId] = React.useState('')
  const [assetType, setAssetType] = React.useState<LabelValue | null>(null)
  const [assetModel, setAssetModel] = React.useState<any>(null)
  const [gatewayId, setGatewayId] = React.useState<any>('')
  const [serialNumber, setSerialNumber] = React.useState<any>('')
  const [applicationType, setApplicationType] = React.useState<any>('')
  const [applicationTypeErrorInit, setApplicationTypeErrorInit] = React.useState(false)
  const [location, setLocation] = React.useState<any>('')
  const [locationErrorInit, setLocationErrorInit] = React.useState(false)
  const [previewImage, setPreviewImage] = React.useState<any>(AddGatewayDummy)
  const [gatewayIdAfterUpdate, setGatewayIdAfterUpdate] = React.useState('')
  const [gatewayImage, setGatewayImage] = React.useState<any>()
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [isStdError, setIsStdError] = React.useState(false)
  const [isCustomError, setIsCustomError] = React.useState(false)
  const [isModbusError, setIsModbusError] = React.useState(false)
  const [ipAddress, setIpAddress] = React.useState('')
  const [ipAddressErrorInit, setIpAddressErrorInit] = React.useState(false)
  const [gatewayName, setGatewayName] = React.useState('')
  const [gatewayNameErrorInit, setGatewayNameErrorInit] = React.useState(false)
  const [gatewayDescription, setGatewayDescription] = React.useState('')
  const [gatewayDescriptionErrorInit, setGatewayDescriptionErrorInit] = React.useState(false)
  const [portNumber, setPortNumber] = React.useState('')
  const [portNumberErrorInit, setPortNumberErrorInit] = React.useState(false)
  const [gatewayType, setGatewayType] = React.useState('')
  const auth = useAuth()
  const thermalCategory = 'Thermal'
  const [protocolOptions, setProtocolOptions] = React.useState<LabelValue[]>([])
  const [timezoneOptions, setTimezoneOptions] = React.useState<LabelValue[]>([])
  const [protocol, setProtocol] = React.useState<LabelValue | null>(null)
  const [timezone, setTimezone] = React.useState<LabelValue | null>(null)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [showImagePopup, setShowImagePopup] = React.useState(false)

  interface StateLocation {
    parentSiteId: string
    deviceAssetId: string
  }
  const navigateState = stateLocation.state as StateLocation | null
  /* istanbul ignore next */
  const parentSiteId = (navigateState != null) ? navigateState.parentSiteId : ''
  const parentAssetId = (navigateState != null) ? navigateState.deviceAssetId : ''
  
  React.useEffect(() => {
    (parentSiteId === '' || parentSiteId === undefined || parentSiteId === null) && navigate('/site-list')
  }, [parentSiteId])

  React.useEffect(() => {
    return () => {
      setIsGatewayDetailsEnabled(true)
      setGatewayIdAfterUpdate('')
      dispatch(ImageUploadReset())
      dispatch(reset())
    };
  }, []);

  React.useEffect(() => {
    /* istanbul ignore next */
    if (!operationPermissions.updated) {
      props?.getOperationPermissions(auth.user?.profile.sub as string)
    }
    props?.fetchAssetCategories()
    props.getCustomDeviceDropdownMetadata()
    props.fetchTimeZones()
    props?.fetchGatewayInfo(gatewayIdParam, parentAssetId)
    props?.downloadImage(gatewayIdParam, 'fdd42da4-4a13-4f57-9e1a-208d95c7f213', '')
  }, [])

  const protocolOptionsData = useSelector((state: RootState) => state.deviceDropDownMetadata.DeviceDropDownMetadata?.protocols)
  const timezoneOptionsData = useSelector((state: RootState) => state.timezoneDropDownMetaData.TimezoneDropDownMetadata)

  React.useEffect(() => {
    if (protocolOptionsData !== undefined && protocolOptionsData.length > 0) {
      let protocolArray: LabelValue[] = []
      protocolArray = protocolOptionsData.map((item: any) => ({
        value: item.commTypeId,
        label: item.commType
      }))
      setProtocolOptions(protocolArray)
    }
  }, [protocolOptionsData])

  React.useEffect(() => {
    if (timezoneOptionsData !== null && timezoneOptionsData.length > 0) {
      let timezoneArray: LabelValue[] = []
      timezoneArray = timezoneOptionsData.map((item: any) => ({
        value: item.zone_id,
        label: item.zone_name
      }))
      setTimezoneOptions(timezoneArray)
    }
  }, [timezoneOptionsData])

  React.useEffect(() => {
    if (props?.gatewayInfo?.gatewayInfo?.device_type !== undefined) {
      setAssetType({
        label: (props.gatewayInfo.gatewayInfo.device_type === 'Thermal-Gateway-TransparentModem' || props.gatewayInfo.gatewayInfo.device_type === 'TransparentModem')  ? 'Transparent Gateway' : props.gatewayInfo.gatewayInfo.device_type,
        value: props?.gatewayInfo?.gatewayInfo?.gateway_type_id ?? 'fdd42da4-4a13-4f57-9e1a-208d95c7f213',
      })
    }
  }, [props?.gatewayInfo?.gatewayInfo?.device_type]);

  React.useEffect(() => {
    setAssetModel({
      label: props?.gatewayInfo?.gatewayInfo?.asset_model_name,
      value: props?.gatewayInfo?.gatewayInfo?.asset_model_id,
    })
  }, [props?.gatewayInfo?.gatewayInfo?.asset_model_id]);

  React.useEffect(() => {
    if(protocolOptions.length > 0) {
      const selectedProtocol = protocolOptions.filter(item => item.value === props?.gatewayInfo?.gatewayInfo?.communication_protocol_id)
      setProtocol(selectedProtocol.length > 0 ? selectedProtocol[0] : null)
    }
  }, [protocolOptions, props?.gatewayInfo?.gatewayInfo?.communication_protocol_id])

  React.useEffect(() => {
    if (timezoneOptions.length > 0) {
      const selectedTimezone = timezoneOptions.filter(item => item.value === props?.gatewayInfo?.gatewayInfo?.timezone)
      setTimezone(selectedTimezone.length > 0 ? selectedTimezone[0] : null)
    }
  }, [timezoneOptions, props?.gatewayInfo?.gatewayInfo?.timezone])

  /* istanbul ignore next */
  React.useEffect(() => {
    if (props?.downloadImageState?.downloadImage?.binaryData !== '') {
      setPreviewImage(props?.downloadImageState?.downloadImage?.binaryData)
    }
  }, [props?.downloadImageState?.downloadImage?.binaryData])

  React.useEffect(() => {
    setGatewayId(props?.gatewayInfo?.gatewayInfo?.id)
    setGatewayName(props?.gatewayInfo?.gatewayInfo?.name || "");
    setGatewayDescription(props?.gatewayInfo?.gatewayInfo?.description || "");
    setIpAddress(props?.gatewayInfo?.gatewayInfo?.ip_address || "");
    setPortNumber(props?.gatewayInfo?.gatewayInfo?.port || "");
    setSerialNumber(props?.gatewayInfo?.gatewayInfo?.serial_number)
    setApplicationType(props?.gatewayInfo?.gatewayInfo?.application_type)
    setGatewayType(props?.gatewayInfo?.gatewayInfo?.device_type|| "");
    setCategoryTypeId(props?.gatewayInfo?.gatewayInfo?.asset_category_id || categoryTypeId)
    setAssetTypeId(props?.gatewayInfo?.gatewayInfo?.asset_type_id || '')
    /* istanbul ignore next */
    const latlong = (props?.gatewayInfo?.gatewayInfo?.latitude !== null && props?.gatewayInfo?.gatewayInfo?.longitude !== null) ? `${props?.gatewayInfo?.gatewayInfo?.latitude},${props?.gatewayInfo?.gatewayInfo?.longitude}` : ''
    setLocation(latlong)
  }, [props?.gatewayInfo?.gatewayInfo?.name]);

  React.useEffect(() => {
    if (props?.updateGatewayState?.data !== undefined && props?.updateGatewayState?.isLoading === false && props.updateGatewayState.data.asset_id) {
      setGatewayIdAfterUpdate(props.updateGatewayState.data.asset_id)
      if (gatewayImage) {
        setShowCreatePopup(false)
        setShowImagePopup(true)
        props?.imageUpload({
          assetId: props.updateGatewayState.data.asset_id,
          assetTypeId: assetType?.value,
          locale: 'en_US',
          file: gatewayImage
        })
      }
    }
  }, [props?.updateGatewayState])

  React.useEffect(() => {
    if (props.assetCategories?.assetCategories != null && props.assetCategories.assetCategories.length > 0) {
      const thermalCat = props.assetCategories.assetCategories.find(
        (cat: any) => cat.category_type_name === thermalCategory
      )
      if (thermalCat != null) {
        setCategoryTypeId(thermalCat.category_type_id)
        props.fetchGatewayType(thermalCat.category_type_id)
      }
    }
  }, [props.assetCategories])

  function handleBreadCrumbsClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void {
    event.preventDefault()
  }

  const handeleCancelClick = (): void => {
    navigate(`/gateway-list/${parentAssetId}`, { state: { parentSiteId } })
  }

  /* istanbul ignore next */
  const moveBackOneStep = (): void => {
    setIsGatewayDetailsEnabled(true)
    setGatewayIdAfterUpdate('')
  }

  const updateGateway = (): void => {
    const putData = {
      type: 'gateway',
      id: gatewayIdParam,
      name: gatewayName,
      description: gatewayDescription,
      ip_address: ipAddress,
      gateway_type_id: assetType?.value ?? '',
      timezone: timezone?.value ?? '',
      communication_protocol_id: protocol?.value ?? '',
      port: protocol?.label !== 'MODBUS-TCP/IP' ? portNumber : ''
    }
    props?.updateGateway(putData)
  }
  
  const handleUpdateGateway = (): void => {
    updateGateway()
  }

  /* istanbul ignore next */
  const handleUpdateGatewayWithFailure = (): JSX.Element => {
    if (props.updateGatewayState.isLoading === false && props.updateGatewayState.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddGatewayStrings.SuccessfullyUpdated} LabelPositive={AddGatewayStrings.okay}
          onClickPositive={() => { setShowCreatePopup(false), handeleCancelClick() }}
          onClose={() => { setShowCreatePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddGatewayStrings.GatewayHasBeenUpdated}</p>
        </Modal>
      )
    } else if (props.updateGatewayState.isLoading) {
      return (
        <Modal title={AddGatewayStrings.UpdatingGateway}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.updateGatewayState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.updateGatewayState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.updateGatewayState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.updateGatewayState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.updateGatewayState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.updateGatewayState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }}
          onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddGatewayStrings.UpdateGatewayError} </p>
        </Modal>
      )
    }
  }

  const handleImageWithFailure = (): JSX.Element => {
    if (props.imageUploadState.isLoading === false && props.imageUploadState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddGatewayStrings.SuccessfullyUpdated} LabelPositive={AddGatewayStrings.okay}
          onClickPositive={() => { setShowImagePopup(false), handeleCancelClick() }}
          onClose={() => { setShowImagePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddGatewayStrings.GatewayHasBeenUpdated}</p>
        </Modal>
      )
    } else if (props.imageUploadState.isLoading) {
      return (
        <Modal title={AddGatewayStrings.UpdatingGateway}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.imageUploadState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.imageUploadState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }}
          onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}>{AddGatewayStrings.UpdateGatewayError}</p>
        </Modal>
      )
    }
  }

  const isGatewayNameNotValid = (): boolean => {
    return (
      !isValidGatewayData(gatewayName) || gatewayName?.length > MAX_LENGTH
    )
  }
  const isGatewayDescriptionNotValid = (): boolean => {
    return (
      !isValidGatewayData(gatewayDescription) || gatewayDescription.length > MAX_GATEWAY_DESCRIPTION_LENGTH
    )
  }
  const isPortNumberNotValid = (): boolean => {
    const port = parseInt(portNumber, 10)
    return !(port > 0 && port <= 65535 && isValidGatewayPort(portNumber) && portNumber.length <= 5)
  }
  const isIpAddressNotValid = (): boolean => {
    return (!isValidIp(ipAddress) || ipAddress.length === 0)
  }
  const isProtocolNotValid = (): boolean => protocol === null
  const isTimezoneNotValid = (): boolean => timezone === null

  const shouldDisableNextButton = (): boolean => {
    return (
      isGatewayNameNotValid() ||
      isIpAddressNotValid() ||
      isGatewayDescriptionNotValid() ||
      isTimezoneNotValid() ||
      isProtocolNotValid() ||
      (protocol?.label !== 'MODBUS-TCP/IP' ? isPortNumberNotValid() : false)
    )
  }
  const shouldDisableAddButton = (): boolean => {
    return (
      isStdError || isCustomError || isModbusError
    )
  }

  if (props?.assetCategories?.isLoading) {
    <div className='CircularprogressAmi'>
      <CircularProgress />
    </div>
  }

  return (
    <div>
      <div role="presentation" data-testid="breadcrumbs" onClick={handleBreadCrumbsClick} className="AmiHeading">
        <ArrowBackIos className="assetmgmtli" data-testid="breadcrumb-arrow-back" aria-label="navArrow" sx={{ marginTop: '10px' }}
          onClick={() => {
            navigate(-1)
          }}
        />
        <Breadcrumbs aria-label='breadcrumb' sx={{ color: '#f0f0f0', fontSize: '12px', marginBottom: '14px', fontFamily: 'Honeywell Sans Web', marginTop: '12px' }}>
          <Link aria-label='navBreadcrumb1' className='assetmgmtli' data-testid="bc-link-1" underline='none' color='inherit' onClick={() => { navigate('/thermal-dashboard') }} >
            {DashboardStrings.HOME}
          </Link>
          <Link aria-label='navBreadcrumb2' className='assetmgmtli' data-testid="bc-link-2" underline='none' color='inherit' onClick={() => { navigate('/site-list') }} >
            {DashboardStrings.SiteManagement}
          </Link>
          <Link aria-label='navBreadcrumb3' className='assetmgmtli' data-testid="bc-link-3" underline='none' color='inherit' 
            onClick={() => { navigate(`/thermal-asset-list/${parentSiteId}`) }}>
            {DashboardStrings.AssetManagement}
          </Link>
          <Link aria-label="navBreadcrumb4" className='assetmgmtli' data-testid="bc-link-4" underline="none" color="inherit"
            onClick={() => {
              navigate(`/gateway-list/${parentAssetId}`, { state: { parentSiteId } })
            }}
          >
            {DashboardStrings.GatewayManagement}
          </Link>
          <Typography color="inherit" sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}>{DashboardStrings.EditGateway}</Typography>
        </Breadcrumbs>
      </div>
      <div className='ArrowGatewayAdd'>
        <div>
          <span style={{ fontSize: '24px', fontWeight: 900, fontStyle: 'normal', lineHeight: '32px' }}
            data-testid='gatewayHistoryDetails'
            className='gatewayMgtGatewaylist'
          >
            {AddGatewayStrings.EditGateway}
          </span>
        </div>
      </div>
      <div>
        <GatewayInformation
          assetModel={assetModel}
          setAssetModel={setAssetModel}
          assetType={assetType}
          setAssetType={setAssetType}
          protocolOptions={protocolOptions}
          protocol={protocol}
          setProtocol={setProtocol}
          timezoneOptions={timezoneOptions}
          timezone={timezone}
          setTimezone={setTimezone}
          gatewayType={props.gatewayType.gatewayType}
          gatewayName={gatewayName}
          setGatewayName={setGatewayName}
          gatewayNameErrorInit={gatewayNameErrorInit}
          setGatewayNameErrorInit={setGatewayNameErrorInit}
          gatewayDescription={gatewayDescription}
          setGatewayDescription={setGatewayDescription}
          gatewayDescriptionErrorInit={gatewayDescriptionErrorInit}
          setGatewayDescriptionErrorInit={setGatewayDescriptionErrorInit}
          portNumber={portNumber}
          setPortNumber={setPortNumber}
          portNumberErrorInit={portNumberErrorInit}
          setPortNumberErrorInit={setPortNumberErrorInit}
          ipAddress={ipAddress}
          setIpAddress={setIpAddress}
          ipAddressErrorInit={ipAddressErrorInit}
          setIpAddressErrorInit={setIpAddressErrorInit}
          applicationType={applicationType}
          setApplicationType={setApplicationType}
          applicationTypeErrorInit={applicationTypeErrorInit}
          setApplicationTypeErrorInit={setApplicationTypeErrorInit}
          location={location}
          setLocation={setLocation}
          locationErrorInit={locationErrorInit}
          setLocationErrorInit={setLocationErrorInit}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          gatewayImage={gatewayImage}
          setGatewayImage={setGatewayImage}
          gatewayId={gatewayId}
        />
      </div>
      <div
        style={{
          height: '80px',
          backgroundColor: '#272727',
          margin: '50px 0 10px 0',
          borderRadius: 10,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 1em'
        }}
      >
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          {(isGatewayDetailsEnabled)
            ? (
              <>
                <Button
                  className='AddGatewayCancelButton'
                  data-testid="cancel-btn-click"
                  onClick={() => {
                    handeleCancelClick()
                  }}
                >
                  {AddGatewayStrings.Cancel}
                </Button>
                <Button
                  dataTestId="next-btn-click"
                  className={`${shouldDisableNextButton() ? 'btn-disabled' : ''}`}
                  onClick={() => { setShowConfirmation(true) }}
                  disabled={shouldDisableNextButton()}
                >
                  {AddGatewayStrings.Update}
                </Button>
              </>
            )
            : (
              <>
                <Button
                  className={`${shouldDisableAddButton() ? 'btn-disabled' : ''}`} dataTestId="add-gateway-btn"
                  onClick={() => { setShowConfirmation(true) }} disabled={shouldDisableAddButton()}
                >
                  {AddGatewayStrings.Update}
                </Button>
              </>
            )}
        </div>
      </div>
      {showConfirmation &&
        <Modal buttonTypeNegative='hollow' title={AddGatewayStrings.UpdatGateway} LabelNegative={AddGatewayStrings.Cancel} LabelPositive={AddGatewayStrings.Confirm} onClickPositive={() => {
          setShowConfirmation(false), setShowCreatePopup(true), handleUpdateGateway()
        }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
          <p style={{ paddingTop: '1.2em' }}>{AddGatewayStrings.GatewayTimeZoneUpdateMessage} <br/> {AddGatewayStrings.GatewayUpdateConfirmation}</p>
        </Modal>
      }
      {showCreatePopup && handleUpdateGatewayWithFailure()}
      {showImagePopup && handleImageWithFailure()}
    </div>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
  fetchAssetCategories: () => void
  fetchGatewayType: (categoryTypeId: string) => void
  fetchGatewayInfo: (gatewayTypeId: string, assetId: string) => void
  updateGateway: (updateGatewayPutRequest: UpdateGatewayPutRequest) => void
  downloadImage: (assetId: string, assetTypeId: string, locale: string) => void
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => void
  getCustomDeviceDropdownMetadata: () => void
  fetchTimeZones: () => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  fetchAssetCategories: () => dispatch(fetchAssetCategories()),
  fetchGatewayType: (categoryTypeId: string) => dispatch(fetchGatewayType(categoryTypeId)),
  fetchGatewayInfo: (gatewayTypeId: string, assetId: string) => dispatch(fetchGatewayInfo(gatewayTypeId, assetId)),
  updateGateway: (updateGatewayPutRequest: UpdateGatewayPutRequest) => dispatch(updateGateway(updateGatewayPutRequest)),
  downloadImage: (assetId: string, assetTypeId: string, locale: string) => dispatch(downloadImage(assetId, assetTypeId, locale)),
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => dispatch(imageUpload(imageUploadPostRequest)),
  getCustomDeviceDropdownMetadata: () => dispatch(getCustomDeviceDropdownMetadata()),
  fetchTimeZones: () => dispatch(fetchTimeZones())
})

interface StateToProps {
  assetCategories: AssetCategoriesState
  gatewayType: GatewayTypeState
  gatewayInfo: GatewayInfoState
  updateGatewayState: UpdateGatewayState
  downloadImageState: DownloadImageState
  imageUploadState: ImageUploadState
  DeviceDropDownMetadata: DeviceDropDownMetadataState
  TimezoneDropDownMetadata: TimezoneDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  assetCategories: state.gatewayManagementAssetCategories,
  gatewayInfo: state.gatewayInfoState,
  gatewayType:state.gatewayManagementGatewayType,
  updateGatewayState: state.updateGatewayState,
  downloadImageState: state.downloadImageStateGateway,
  imageUploadState: state.imageUploadStateGateway,
  DeviceDropDownMetadata: state.deviceDropDownMetadata,
  TimezoneDropDownMetadata: state.timezoneDropDownMetaData
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(EditGateway)
